import { Activity, CheckCircle, XCircle, AlertCircle } from "lucide-react"
import { useIntl } from "react-intl"

const getStatusIcon = (status) => {
  switch (status) {
    case true:
      return <CheckCircle className="h-4 w-4 text-emerald-600" />
    case false:
      return <XCircle className="h-4 w-4 text-red-600" />
    default:
      return <AlertCircle className="h-4 w-4 text-gray-500" />
  }
}

const getStatusColor = (status) => {
  switch (status) {
    case "active":
      return "bg-emerald-50 text-emerald-700 border-emerald-200"
    case "completed":
      return "bg-emerald-50 text-emerald-700 border-emerald-200"
    case "error":
      return "bg-red-50 text-red-700 border-red-200"
    default:
      return "bg-gray-50 text-gray-600 border-gray-200"
  }
}

export default function JobHeader({ selectedJob, activeRangeKey = "1W", onRangeChange = () => { } }) {
  const intl = useIntl()
  const ranges = [
    { key: "1D", label: intl.formatMessage({ id: "dga.ranges.1d", defaultMessage: "1D" }) },
    { key: "1W", label: intl.formatMessage({ id: "dga.ranges.1w", defaultMessage: "1W" }) },
    { key: "1M", label: intl.formatMessage({ id: "dga.ranges.1m", defaultMessage: "1M" }) },
    { key: "1Y", label: intl.formatMessage({ id: "dga.ranges.1y", defaultMessage: "1Y" }) },
  ]

  return (
    <div className="border-b border-gray-200 bg-white p-4">
      <div className="flex flex-col sm:!flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">{selectedJob.region_code}</h2>
          <h5 className="text-gray-700 text-xs">
            {selectedJob?.description?.length > 100
              ? `${selectedJob?.description?.substring(0, 100)}...`
              : selectedJob?.description}
          </h5>
        </div>
        <div className="flex items-center gap-3">
          <div className="inline-flex rounded-md border border-gray-200 bg-gray-50 p-1">
            {ranges.map(r => (
              <button
                key={r.key}
                onClick={() => onRangeChange(r.key)}
                className={`px-2.5 py-1 text-xs font-medium rounded-md transition-colors ${activeRangeKey === r.key
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900"
                  }`}
              >
                {r.label}
              </button>
            ))}
          </div>
          <div className="flex items-center">
            {getStatusIcon(selectedJob.enabled)}
          </div>
        </div>
      </div>
    </div>
  )
}
